module.exports = __webpack_public_path__ + "static/istock-510591412-compressor-f8a6ed79fa859eafecef144c836f8beb.jpg";